import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 4 hours in seconds
  const [timeLeft, setTimeLeft] = useState(4 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center space-x-2 text-2xl font-bold text-amber-400 font-poppins" data-id="element-77">
      <div className="bg-gray-900/80 px-3 py-2 rounded-lg border border-amber-500/30 min-w-[60px] text-center shadow-inner shadow-black/50" data-id="element-78">
        {hours.toString().padStart(2, '0')}
        <span className="block text-xs text-gray-400 font-normal mt-1 tracking-widest" data-id="element-79">
          HORAS
        </span>
      </div>
      <span className="text-amber-500 pb-5 animate-pulse" data-id="element-80">:</span>
      <div className="bg-gray-900/80 px-3 py-2 rounded-lg border border-amber-500/30 min-w-[60px] text-center shadow-inner shadow-black/50" data-id="element-81">
        {minutes.toString().padStart(2, '0')}
        <span className="block text-xs text-gray-400 font-normal mt-1 tracking-widest" data-id="element-82">
          MIN
        </span>
      </div>
      <span className="text-amber-500 pb-5 animate-pulse" data-id="element-83">:</span>
      <div className="bg-gray-900/80 px-3 py-2 rounded-lg border border-amber-500/30 min-w-[60px] text-center shadow-inner shadow-black/50" data-id="element-84">
        {seconds.toString().padStart(2, '0')}
        <span className="block text-xs text-gray-400 font-normal mt-1 tracking-widest" data-id="element-85">
          SEG
        </span>
      </div>
    </div>;
}